<template>
  <div id="baned">
    <img src="../../assets/list/band(4).jpg" />
    <div class="list">
      <!--A-->
      <table>
        <div class="title relativeItem">违法涉政内容-A类</div>
        <tr class="item flex-box" v-for="(n, index) in list_a" :key="index" align="center">
          <td class="s1">{{ n.nickname }}</td>
          <td class="s2">{{ n.content }}</td>
        </tr>
        <div class="title relativeItem">查获处罚</div>
        <tr>
          <td class="s3">首次查获，立即永久封停帐号，签约直播将终止合作协议(扣50分)</td>
        </tr>
      </table>

      <!--B-->
      <table>
        <div class="title relativeItem">违法涉政内容-B类</div>
        <tr class="item flex-box" v-for="(n, index) in list_b" :key="index" align="center">
          <td class="s1">{{ n.nickname }}</td>
          <td class="s2">{{ n.content }}</td>
        </tr>
        <div class="title relativeItem">查获处罚</div>
        <tr>
          <td class="s3">首次查获：封停帐号一周(扣20分）</td>
        </tr>
        <tr>
          <td class="s3">第二次查获：封停帐号一月(扣20分）</td>
        </tr>
        <tr>
          <td class="s3">第三次查获：永久封停帐号，签约艺人将终止合作协议(扣50分)</td>
        </tr>
      </table>

      <!--C-->
      <table>
        <div class="title relativeItem">不雅内容-C类</div>
        <tr class="item flex-box" v-for="(n, index) in list_c" :key="index" align="center">
          <td class="s1">{{ n.nickname }}</td>
          <td class="s2">{{ n.content }}</td>
        </tr>
        <div class="title relativeItem">查获处罚</div>
        <tr>
          <td class="s3">首次查获：警告（不扣分）</td>
        </tr>
        <tr>
          <td class="s3">第二次查获：不封停账号（10分）</td>
        </tr>
        <tr>
          <td class="s3">第三次查获：封停帐号24小时(扣20分）</td>
        </tr>
      </table>

      <!--D-->
      <table>
        <div class="title relativeItem">影响直播专业性-D类</div>
        <tr class="item flex-box" v-for="(n, index) in list_d" :key="index" align="center">
          <td class="s1">{{ n.nickname }}</td>
          <td class="s2">{{ n.content }}</td>
        </tr>
        <div class="title relativeItem">查获处罚</div>
        <tr>
          <td class="s3">首次查获：警告（不扣分）</td>
        </tr>
        <tr>
          <td class="s3">第二次查获：不封停账号（5分）</td>
        </tr>
        <tr>
          <td class="s3">第三次查获：封停帐号一周(扣15分）</td>
        </tr>
      </table>

      <!--注意事项-->
      <p class="tiptext">注：本违规内容处罚非唯一评判标准，平台有权根据情节严重程度提高违规处罚。</p>
    </div>
    <div class="relativeItem">
      <img src="../../assets/list/band(3).jpg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "baned",
  data() {
    return {
      list: [],
      list_a: [
        {
          nickname: "反党反社会",
          content:
            "发布反党反社会言论直播中评论群体事件或重大灾害的，包括但不限于游行、集会、静坐、针对政府/国企拉横幅，上访，火灾、车祸、抢劫、伤害事件现场，自然灾害，抗灾救援等"
        },
        {
          nickname: "侮辱党和领导人",
          content: "发布侮辱党和国家领导人的言论"
        },
        {
          nickname: "煽动族群仇恨",
          content:
            "话题涉及政治或煽动不同民族、不同职业、不同阶层、不同地区或不同国家间相互仇恨的表演"
        },
        {
          nickname: "违禁品",
          content: "播出涉枪支弹药展示、出售、拆解等内容，包括仿真枪支、刀具等"
        },
        {
          nickname: "吸毒",
          content: "吸毒或宣传、模仿吸毒，K粉等言论及动作"
        },
        {
          nickname: "机关制服",
          content: "艺人身穿国家机关工作人员制服直播"
        },
        {
          nickname: "直播性行为",
          content:
            "直接展示具有性特征的身体敏感部位（如女性胸部，男女性生殖器官等），直播性行为等"
        },
        {
          nickname: "违法犯罪",
          content:
            "宣扬国家明令禁止的违法犯罪行为，包括但不限于涉及传销、诈骗、邪教组织的信息或表演"
        }
      ],
      list_b: [
        {
          nickname: "色情表演",
          content:
            "性挑逗性质的表演，如表演时抚摸或展露敏感部位，做出有可能使人联想到色情行为的动作，谈论性经验、性生活、性器官、性药等，或模仿带有性挑逗性质的声音 "
        },
        {
          nickname: "反伦理道德",
          content: "宣扬涉及一夜情、SM、换妻、婚外恋等不符合主流伦理道德的信息"
        },
        {
          nickname: "色情链接、视频",
          content: "主播发布包含色情内容的黄色网链接、淫秽视频"
        },
        {
          nickname: "脱衣舞",
          content: "进行脱衣舞等具有挑逗性的表演"
        },
        {
          nickname: "裸露敏感部位",
          content:
            "赤身表演或者将臀部、大腿内侧、胸部等不适宜外露的部位展示在视频上"
        },
        {
          nickname: "抹黑、谩骂及诽谤他人",
          content: "抹黑、诋毁攻击他人，或挑起事端，及泄露他人隐私等 "
        },
        {
          nickname: "公共安全骚扰",
          content:
            "拨打110，119，112等类似性质电话、喊麦(不限类型内容,一律处罚)"
        }
      ],
      list_c: [
        {
          nickname: "色情图片",
          content: "发布低俗，或容易引起性联想的图片"
        },
        {
          nickname: "成人用品",
          content:
            "画面中出现成人用品道具、性用品、内衣等涉及不雅内容的物品作为表演道具"
        },
        {
          nickname: "赌博",
          content: "主播在直播过程中有赌博行为"
        },
        {
          nickname: "吸烟喝酒",
          content: "在直播时吸烟，喝酒，或者酒后直播"
        },
        {
          nickname: "暴力表演",
          content:
            "表演有可能伤害他人或自己的行为，如自残、自杀、互殴、殴打他人等"
        },
        {
          nickname: "擦边色情",
          content: "主播表现或隐晦表现带有性行为、挑逗性或侮辱性的内容（擦边）"
        },
        {
          nickname: "衣着暴露",
          content:
            "表演时衣冠不整或穿着过于暴露（内衣、泳装、透视装、肉色紧身衣、爆乳装、过于裸露的短裙）"
        }
      ],
      list_d: [
        {
          nickname: "色情图片",
          content: "发布低俗，或容易引起性联想的图片"
        },
        {
          nickname: "睡衣直播",
          content:
            "主播身穿低胸装、不带衣袖（漏肩）的上装进行直播（包括护士装、女仆装、空姐服、女警、水手服等所有带有制服诱惑挑逗含义的服饰）"
        },
        {
          nickname: "长时间离开",
          content: "主播长时间（超过10分钟）不出现在视频画面中或目光未聚焦镜头"
        },
        {
          nickname: "宣传竞争对手",
          content: "主播在直播时宣传其他竞争语音平台"
        },
        {
          nickname: "违规广告",
          content:
            "主播在直播时宣传其他平台广告及活动信息（违规宣传位置包括昵称，直播间名，滚动文字）（注：口头宣传不能超过5分钟，每档宣传不得超过3次）"
        },
        {
          nickname: "擦边色情",
          content: "主播表现或隐晦表现带有性行为、挑逗性或侮辱性的内容（擦边）"
        },
        {
          nickname: "主播不雅（提醒）",
          content: "主播昵称中出现不雅，低俗"
        },
        {
          nickname: "无关人员（代播）",
          content: "视频中出现与实名认证无关人员，由他人代替主播自己直播"
        },
        {
          nickname: "实名认证",
          content: "非本人实名认证开展直播查获永久封停"
        }
      ]
    };
  },
  methods: {
    getList() {
      let _this = this;
      this.$jsonp(this.$apis("bandlist"), {}, res => {
        _this.list = res.data.data.result.list;
      });
    }
  },
  mounted: function() {
    this.$tool.setTitle("违规内容");
    this.getList();
  },
  watch: {}
};
</script>









<style scoped>
img {
  display: block;
}
a {
  top: 10%;
  font-size: 12px;
  color: white;
  border-bottom: 1px solid #fff;
}
.list {
  background: url("../../assets/list/band.jpg") repeat left top;
  background-size: 100% 100%;
  overflow: hidden;
}

table {
  width: 85%;
  margin: 0 auto;
  border: 1px solid #feca57;
  border-top: none;
  min-height: 500px;
  border-collapse: collapse;
  table-layout: fixed;
  margin-bottom: 40px;
}

tr {
  border-bottom: 1px solid #feca57;
  position: relative;
  align-items: center;
}
.item {
  position: relative;
}
.item::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  background: #feca57;
  top: 0;
  left: 35%;
}

td {
  font-size: 11px;
  display: inline-block;
  padding: 12px 10px;
  height: 100%;
  text-align: center;
  word-wrap: break-word;
}
.title {
  height: 30px;
  width: 100%;
  display: inline-block;
  background: #feca57;
  color: #944b38;
  padding: 0;
  line-height: 30px;
  font-size: 11px;
  text-align: center;
}

.s1 {
  width: 35%;
}
.s2 {
  width: 65%;
  text-align: justify;
}
.s2 {
  border-right: 0 !important;
}
tr:last-child {
  border-bottom: 0;
}

.tiptext {
  width: 85%;
  margin: 0 auto;
  color: #944b38;
  line-height: 20px;
  font-size: 13px;
}
</style>
